export const capitalize = s => s.slice(0, 1).toUpperCase() + s.slice(1);

export const titleize = s =>
  s.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });

export const parameterize = s =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");





// WEBPACK FOOTER //
// ./src/utils/string.js